export const tooltipContent =
  '"Week to Date" refers to last Friday through the most recent update. The update can differ for each DSP.';
const concertsTooltipContent =
  'Number of Songkick users that reported their attendance';
const positionTrackerTooltipContent =
  'The official local charts are the weekly official singles charts in each country';

const getTooltipContent = (tableName?: string): string => {
  switch (tableName) {
    case 'BrowseOpus':
      return tooltipContent;
    case 'concerts':
      return concertsTooltipContent;
    case 'positionTracker':
      return positionTrackerTooltipContent;
    default:
      return '';
  }
};

export default getTooltipContent;
